import {
  TableActionCellProps,
  TableActionCellSecondaryAction,
  TableActionCellSecondaryDivider,
} from '@wix/design-system';
import { FiltersMap } from '@wix/bex-core';
import { ActionsCellAPI } from '../../state';

export type SecondaryAction =
  | (TableActionCellSecondaryAction & {
      biName?: string;
      componentId?: string;
      appId?: string;
    })
  | TableActionCellSecondaryDivider;

export interface ActionsCellProps
  extends Omit<TableActionCellProps, 'primaryAction' | 'secondaryActions'> {
  /**
   * WSR TableActionCellProps's primaryAction with extra optional fields:
   * - `biName` - the bi name of the action
   * - `disabledMessage` - the message to show when the action is disabled
   * @external
   */
  primaryAction?: TableActionCellProps['primaryAction'] & {
    biName?: string;
    disabledMessage?: string;
  };
  /**
   * WSR TableActionCellProps's secondaryActions + optional `biName`
   * @external
   */
  secondaryActions?: SecondaryAction[];

  /**
   * This ID is used to specify the target container for extension menu items.
   * Read more on [Extensions](https://bo.wix.com/pages/cairo/?path=/story/guides--extensions)
   */
  containerId?: string;
}

export type ActionsCell<T, F extends FiltersMap> =
  | ActionsCellProps
  | ((item: T, index: number, api: ActionsCellAPI<T, F>) => ActionsCellProps);
